const header = ''
import draggable from 'vuedraggable'
import TmpStore from '@/view/weappTmp/core/lib/base/store.js'
import { getRandwords } from '@/utils'
export default {
  components: {
    draggable
  },
  props: {
    relStore: {
      type: Object,
      default: () => {
        return {}
      }
    },
    importParentAPI: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      editorIndex: null,
      editorData: {},
      editorDataIndex: null,
      components: [],
      headerBg: header,
      canEdit: false,
      componentsMap: {}
    }
  },
  created () {
    // console.log('mixin执行')
  },
  methods: {
    setHomeConfig (index,type) {
      const { removueHomeEditorIndex, setHomeConfig } = this.importParentAPI()
      removueHomeEditorIndex(type)
      setHomeConfig(index,type)
    },
    // 设置当前编辑的组件
    setCurrent (val, type) {
      // console.log('setCurrent-type',type,val)
      TmpStore.setVal('editorIndex', val)

      if (val !== null) {
        this.editorData = { ...this.components[val] }
        this.editorIndex = val
      } else {
        // console.log('setCurrent-null')
        this.editorIndex = null
        this.editorDataIndex = null
      }
      this.editorData.editorIndex = val
      this.$emit('editorChange', {
        editorData: this.editorData,
        editorIndex: this.editorIndex
      })
      if (type == 'homeSet') {
        // TmpStore.setHook('target',this.editorData)
      }
      // console.log('setCurrent-setTarget',this.editorData)
      TmpStore.setVal('target', this.editorData)
    },

    cancelAction () {
      this.$emit('closeDialog')
    },
    getRandwords () {
      return getRandwords()
    }
    // // 拖拽绑定事件
  }
}
